import { Box, SxProps, Theme } from "@mui/material";
import { FileIcon as ReactFileIcon, defaultStyles, DefaultExtensionType } from "react-file-icon"

export type FileIconProps = {
    extension: string;
    size?: 'small' | 'medium' | 'large';
    sx?: SxProps<Theme>;
}

export const FileIcon = (props: FileIconProps) => {
    const getValidExtensionType = (value: string): DefaultExtensionType | null => {
        if (extensions.includes(value)) {
            return value as DefaultExtensionType;
        }
        return null;
    }

    const extension = getValidExtensionType(props.extension);

    const getStyles = (extension: DefaultExtensionType) => {
        if (extension === 'csv') return defaultStyles.xlsx;
        return defaultStyles[extension];
    }

    const size = props.size || 'medium';

    const getWidth = () => {
        switch (size) {
            case 'small':
                return 18;
            case 'large':
                return 32;
            default:
                return 24;
        }
    }

    const width = getWidth();

    return <Box sx={{ width, flexShrink: 0, ...props.sx }}>
        <ReactFileIcon extension={extension || "?"} {...getStyles(extension || 'txt')} />
    </Box>
}

export const extensions: string[] = [
    "3dm", "3ds", "3g2", "3gp", "7zip", "aac", "aep", "ai", "aif", "aiff", "asf", "asp", "aspx", "avi", "bin", "bmp",
    "c", "cpp", "cs", "css", "csv", "cue", "dll", "dmg", "doc", "docx", "dwg", "dxf", "eot", "eps", "exe", "flac", "flv",
    "fnt", "fodp", "fods", "fodt", "fon", "gif", "gz", "htm", "html", "indd", "ini", "java", "jpeg", "jpg", "js", "json",
    "jsx", "m4a", "m4v", "max", "md", "mid", "mkv", "mov", "mp3", "mp4", "mpeg", "mpg", "obj", "odp", "ods", "odt", "ogg",
    "ogv", "otf", "pdf", "php", "pkg", "plist", "png", "ppt", "pptx", "pr", "ps", "psd", "py", "rar", "rb", "rm", "rtf",
    "scss", "sitx", "svg", "swf", "sys", "tar", "tex", "tif", "tiff", "ts", "ttf", "txt", "wav", "webm", "wmv", "woff",
    "wpd", "wps", "xlr", "xls", "xlsx", "yml", "zip", "zipx",
]